const menuItems = {
  items: [
    {
      id: 'support',
      title: 'Member',
      type: 'Member',
      icon: 'icon-support',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'Member',
          url: '/member-dashboard',
          classes: 'nav-item',
          icon: 'fas fa-chart-line',
          color: 'orange'
        },
        {
          id: 'account',
          title: 'Account',
          type: 'collapse',
          // url: '/ledger',
          classes: 'nav-item',
          icon: 'fas fa-file-invoice-dollar',
          color: 'blue',
          children: [
            {
              id: 'ledger',
              title: 'Transaction',
              type: 'item',
              url: '/ledger',
              classes: 'nav-item',
              // icon: 'fas fa-file-invoice-dollar',
              color: 'blue'
            },
            {
              id: 'billview',
              title: 'KOT Bill',
              type: 'item',
              url: '/view_bill',
              classes: 'nav-item',
              // icon: 'fa-solid fa-file-invoice',
              color: '#08beee'
            },
            {
              id: 'bill',
              title: 'Monthly Bills',
              type: 'item',
              url: '/member-bill',
              classes: 'nav-item',
              // icon: 'fas fa-money-bill',
              color: '#ACED07'
            }
          ]
        },
           
        // {
        //   id: 'billview',
        //   title: 'View Bill',
        //   type: 'Member',
        //   url: '/view_bill',
        //   classes: 'nav-item',
        //   icon: 'fa-solid fa-file-invoice',
        //   color: '#08beee'
        // },
        {
          id: 'billviews',
          title: 'Bar and Restaurant Bills',
          type: 'Member',
          url: '/view_bill',
          classes: 'nav-item',
          icon: 'fa-solid fa-file-invoice',
          color: '#08beee'
        },
        {
          id: 'pendingbill',
          title: 'Pending Bills',
          type: 'Member',
          url: '/pending-bills',
          classes: 'nav-item',
          icon: 'fa-solid fa-money-bill-transfer',
          color: '#Ff0000'
        },
      

        {
          id: 'onlinpayment',
          title: 'Online Payment',
          type: 'Member',
          url: '/member-onlinepayment',
          classes: 'nav-item',
          icon: 'fas fa-credit-card',
          color: 'green'
        },
        {
          id: 'event',
          title: 'Events',
          type: 'Member',
          url: '/member-event',
          classes: 'nav-item',
          icon: 'fas fa-calendar-check',
          color: 'orange'
        },
        {
          id: 'room',
          title: 'Cottages',
          type: 'Member',
          url: '/rooms_list',
          classes: 'nav-item',
          icon: 'fa-solid fa-people-roof',
          color: 'red'
        },
      {
          id: 'MyRooms',
          title: 'My Rooms',
          type: 'Member',
          url: '/booking-details',
          classes: 'nav-item',
          icon: 'fa-solid fa-people-roof',
          color: '#07f7c9'
        },

        {
          id: 'golfbook',
          title: 'Booking',
          type: 'Member',
          url: '/golf-bookinglist',
          classes: 'nav-item',
          icon: 'fa-solid fa-golf-ball-tee',
          color: '#6c00ff'
        },
        {
          id: 'MemberGallery',
          title: 'Gallery',
          type: 'Member',
          url: '/membergallery',
          classes: 'nav-item',
          icon: 'fas fa-photo-film',
          color: 'yellow'
        },
        {
          id: 'room-available',
          title: 'Room Booking',
          // title: 'Room Booking',
          type: 'Member',
          url: '/room-available',
          classes: 'nav-item',
          icon: 'feather icon-home',
          color: '#07f7c9'
        },

        {
          id: 'kot',
          title: 'Orders',
          type: 'Member',
          url: '/member-kot',
          classes: 'nav-item',
          icon: 'fa-solid fa-mug-hot',
          color: '#09b02d'
        },
        {
          id: 'facilitybooking',
          title: 'Facilities Booking',
          type: 'Member',
          url: '/facility_booking',
          classes: 'nav-item',
          icon: 'fa-solid fa-check-to-slot',
          color: 'orange'
        },

        {
          id: 'clubvisit',
          title: 'Club Visit',
          type: 'Member',
          url: '/club_visit',
          classes: 'nav-item',
          icon: 'fa-solid fa-hotel',
          color: '#4dee08'
        },
        
        
        // {
        //   id: 'commitee',
        //   title: 'Committee Members',
        //   type: 'Member',
        //   url: '/member-committee',
        //   classes: 'nav-item',
        //   icon: '	fas fa-address-card',
        //   color: 'lightsalmon'
        // },

        // {
        //   id: 'qr',
        //   title: 'QRCode',
        //   type: "Member",
        //   url: '/member-qr',
        //   classes: 'nav-item',
        //   icon: 'feather icon-slack'
        // },
        // {
        //   id: 'news',
        //   title: 'NEWSLETTER',
        //   type: "Member",
        //   url: '/member-newsletter',
        //   classes: 'nav-item',
        //   icon: 'feather icon-slack'
        // },
        // {
        //   id: 'club',
        //   title: 'Affiliated Club',
        //   type: 'Member',
        //   url: '/member-club',
        //   classes: 'nav-item',
        //   icon: 'fas fa-user',
        //   color: 'Crimson'
        // },

        {
          id: 'board',
          title: 'Notice Board',
          type: 'Member',
          url: '/member-noticeboard',
          classes: 'nav-item',
          icon: 'far fa-clipboard',
          color: '#e20cdd'
        },
        {
          id: 'suggestion',
          title: 'Suggestion',
          type: 'Member',
          url: '/membersuggestionlist',
          classes: 'nav-item',
          icon:'fas fa-pencil-alt',
          color: '#6c00ff'
        },
 {
          id: 'feedback',
          title: 'Feedback',
          type: 'Member',
          url: '/feedback_list',
          classes: 'nav-item',
          icon: 'fa-regular fa-comment',
          color: '#6c00ff'
        },
        // {
        //   id: 'rules',
        //   title: 'Rules',
        //   type: 'collapse',
        //   // url: '/rules',
        //   classes: 'nav-item',
        //   icon: 'fa fa-gavel',
        //   color: '#ee087e',
        //   children: [
        //     {
        //       id: 'clubrules',
        //       title: 'Club Rules',
        //       type: 'item',
        //       url: '/rules',
        //       classes: 'nav-item',
        //       // icon: 'fa fa-gavel',
        //       color: '#1d84da'
        //     },
        //     {
        //       id: 'dressrules',
        //       title: 'Dress Rules',
        //       type: 'item',
        //       url: '/dresscode_rules',
        //       classes: 'nav-item',
        //       // icon: 'fa fa-gavel',
        //       color: '#1d84da'
        //     }
        //   ]
        // },

        // {
        //   id: 'facility',
        //   title: 'Facility List',
        //   type: 'Member',
        //   url: '/facility_slot',
        //   classes: 'nav-item',
        //   icon: 'fa-solid fa-calendar-days',
        //   color: '#1d84da'
        // },

        // {
        //   id: 'QR',
        //   title: 'QR Attandance',
        //   type: "Member",
        //   url: '/qr_attendance',
        //   classes: 'nav-item',
        //   icon: 'fa-solid fa-qrcode',
        //   color: "#7c1dda"
        // },

       
        // {
        //   id: 'golf',
        //   title: 'Golf Booking',
        //   type: "Member",
        //   url: '/golf-booking',
        //   classes: 'nav-item',
        //   icon: 'fas fa-info',
        //   color: "#6c00ff"
        // },/movie_booking<i class="fa-solid fa-film"></i>
        {
          id: 'moviebooking',
          title: 'Survey',
          type: 'Member',
          url: '/movie_booking',
          classes: 'nav-item',
          icon: 'fa-solid fa-film',
          color: 'red'
        },
        {
          id: 'aboutus',
          title: 'About Us',
          type: 'collapse',
          url: '/member-about',
          classes: 'nav-item',
          icon: 'fas fa-info',
          color: '#6c00ff',
          children : [
            {
              id: 'history',
              title: 'Club History',
              type: 'item',
              url: '/Willigtonhistory',
              classes: 'nav-item',
              // icon: 'fas fa-info',
              color: '#6c00ff'
            },
            {
              id: 'comittee members',
              title: 'Committee members',
              type: 'item',
              url: '/member-committee',
              classes: 'nav-item',
              // icon: 'fas fa-address-card',
              color: '#6c00ff'
            },
            // {
            //   id: 'office bearers',
            //   title: 'Office bearers',
            //   type: 'item',
            //   url: '/office-bearers',
            //   classes: 'nav-item',
            //   // icon: 'fas fa-address-card',
            //   color: '#6c00ff'
            // },
            {
              id: 'FacilityList',
              title: 'Facility Info',
              type: 'item',
              url: '/facility_slot',
              classes: 'nav-item',
              // icon: 'fa-solid fa-check-to-slot',
              color: '#6c00ff'
            },
           
            {
              id: 'member club',
              title: 'Affiliated Clubs',
              type: 'item',
              url: '/member-club',
              classes: 'nav-item',
              // icon: 'fas fa-user',
              color: '#6c00ff'
            },
            {
              id: 'dresscode',
              title: 'Dress Code',
              type: 'item',
              url: '/dresscode_rules',
              classes: 'nav-item',
              // icon: 'fa fa-gavel',
              color: '#6c00ff'
            },
            {
              id: 'crules',
              title: 'Club Rules & Regulations',
              type: 'item',
              url: '/rules',
              classes: 'nav-item',
              // icon: 'fa fa-gavel',
              color: '#6c00ff'
            },
            // {
            //   id: 'suggestion',
            //   title: 'Suggestion',
            //   type: 'item',
            //   url: '/membersuggestionlist',
            //   classes: 'nav-item',
            //   // icon: 'fa fa-gavel',
            //   color: '#6c00ff'
            // },
          ]
        },
       
        {
          id: 'contactus',
          title: 'Contact Us',
          type: 'Member',
          url: '/cwmember-about',
          classes: 'nav-item',
          icon: 'fa-solid fa-phone',
          color: 'red'
        },
      ]
    },
    {
      id: 'support',
      title: 'Admin',
      type: 'Admin',
      icon: 'icon-support',
      children: [
        {
          id: 'DashBoard',
          title: 'Dashboard',
          type: 'Admin',
          url: '/admin-dashboard',
          classes: 'nav-item',
          icon: 'fas fa-chart-line',
          color: 'orange'
        },
        {
          id: 'memberlist',
          title: 'Member List',
          type: 'Admin',
          url: '/admin-memberlist',
          classes: 'nav-item',
          icon: 'fas fa-users',
          color: 'green'
        },
        {
          id: 'paymentlist',
          title: 'Payment List',
          type: 'Admin',
          url: '/admin-paymentlist',
          classes: 'nav-item',
          icon: 'fas fa-receipt',
          color: 'darkblue'
        },
        {
          id: 'staff',
          title: 'Staffs',
          type: 'Admin',
          url: '/staff',
          classes: 'nav-item',
          icon: 'fa-regular fa-user',
          color: '#ec06e9'
        },
        {
          id: 'FacilityInfo',
          title: 'Facility List',
          type: 'Admin',
          url: '/hall-list',
          classes: 'nav-item',
          icon: 'fa-regular fa-building',
          color: 'orange'
        },
        {
          id: 'ChangeRequest',
          title: 'Change Request',
          type: 'Admin',
          url: '/change-request',
          classes: 'nav-item',
          icon: 'fa-solid fa-code-pull-request',
          color: '#ff0000'
        },
        {
          id: 'Events',
          title: 'Events',
          type: 'Admin',
          url: '/admin-eventlist',
          classes: 'nav-item',
          icon: 'fas fa-calendar-check',
          color: '#09b02d'
        },
        {
          id: 'EventReport',
          title: 'Event Report',
          type: 'Admin',
          url: '/admin-eventreports',
          classes: 'nav-item',
          icon: 'fa-solid fa-file-contract',
          color: '#1d84da'
        },
        {
          id: 'EventNotification',
          title: 'Event Notification',
          type: 'Admin',
          url: '/notification_list',
          classes: 'nav-item',
          icon: 'fa-solid fa-bell',
          color: '#09b02d'
        },
        {
          id: 'Gallery',
          title: 'Gallery',
          type: 'Admin',
          url: '/admin-gallerylist',
          classes: 'nav-item',
          icon: 'fas fa-photo-film',
          color: 'yellow'
        },     {
          id: 'Digital',
          title: 'Digital Showroom',
          type: 'Admin',
          url: '/digital-showroom-list',
          classes: 'nav-item',
          icon: 'fa-solid fa-business-time',
          color: 'green'
        },
       {
          id: 'Cottages',
          title: 'Cottages',
          type: 'Admin',
          url: '/rooms',
          classes: 'nav-item',
          icon: 'fa-solid fa-hotel',
          color: '#6cff09'
        },
        {
          id: 'Catering',
          title: 'Catering',
          type: 'Admin',
          url: '/order_detail',
          classes: 'nav-item',
          icon: 'fa-solid fa-cart-shopping',
          color: 'darkblue'
        },
        // {<i class="fa-solid fa-business-time"></i>
        //   id: 'facility',
        //   title: 'Facility List',
        //   type: "Admin",
        //   url: '/facility_view',
        //   classes: 'nav-item',
        //   icon: 'fa-solid fa-house',
        //   color: "#0089ff"
        // },

        {
          id: 'NoticeBoard',
          title: 'Notice List',
          type: 'Admin',
          url: '/admin-noticelist',
          classes: 'nav-item',
          icon: 'far fa-clipboard',
          color: '#ff0000'
        },
        {
          id: 'FeedBack',
          title: 'Feedback',
          type: 'Admin',
          url: '/feedbacklist',
          classes: 'nav-item',
          icon: 'fa-regular fa-comment',
          color: '#0181f7'
        },
        {
          id: 'Suggestion',
          title: 'AdminSuggestion',
          type: 'Admin',
          url: '/suggestionlist',
          classes: 'nav-item',
          icon: 'fas fa-pencil-alt' ,
          color: '#0181f7'
        },
          {
          id: 'affiliatedlist',
          title: 'Affiliated Clubs',
          type: 'Admin',
          url: '/admin-affiliatedlist',
          classes: 'nav-item',
          icon: 'fa-solid fa-handshake-simple',
          color: '#6c00ff'
        },
        {
          id: 'Rules',
          title: 'Rules',
          type: 'collapse',

          classes: 'nav-item',
          icon: 'fa fa-gavel',
          color: '#2d6466',
          children: [
            {
              id: 'clubrules',
              title: 'Club Rules',
              type: 'item',
              url: '/rules_list',
              classes: 'nav-item',
              icon: 'fa fa-gavel',
              color: '#1d84da'
            },
            {
              id: 'dressrules',
              title: 'Dress Rules',
              type: 'item',
              url: '/dresscode_rules_list',
              classes: 'nav-item',
              icon: 'fa fa-gavel',
              color: '#1d84da'
            }
          ]
        },
        
        {
          id: 'FacilitiesBooking',
          title: 'Facility',
          type: 'collapse',
          // url: '/member-slot-booking-details',
          classes: 'nav-item',
          icon: 'fa-solid fa-house',
          color: 'blue',
          children: [
            {
              id: 'Bookdetails',
              title: 'Booking Details',
              type: 'item',
              url: '/member-slot-booking-details',
              classes: 'nav-item',
              icon: 'fa-solid fa-calendar-days',
              color: '#1d84da'
            },
           
            {
              id: 'AddFacility',
              title: 'Slot Details',
              type: 'item',
              url: '/slot_details',
              classes: 'nav-item',
              icon: 'fa-solid fa-dumbbell',
              color: '#1d84da'
            }
          ]
        },
        
        {
          id: 'Survey',
          title: 'Survey',
          type: 'Admin',
          url: '/movie-details',
          classes: 'nav-item',
          icon: 'fa-solid fa-film',
          color: 'red'
        },

        {
          id: 'AboutUs',
          title: 'About Us',
          type: 'Admin',
          url: '/admin-about',
          classes: 'nav-item',
          icon: 'fas fa-info',
          color: '#6c00ff'
        }
        // {
        //   id: 'newsletter',
        //   title: 'NEWSLETTER',
        //   type: 'Admin',
        //   url: '/admin-newsletter',
        //   classes: 'nav-item',
        //   icon: 'feather icon-list'
        // }feedbacklist  /slot_details
      ]
    },
    {
      id: 'support',
      title: 'Affiliated Club',
      type: 'club',
      icon: 'icon-support',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'Admin',
          url: '/affiliated-dashboard',
          classes: 'nav-item',
          icon: 'fas fa-chart-line',
          color: 'orange'
        }
      ]
    }
  ]
};

export default menuItems;
